import { IPagamentoRow } from 'pages/pagamento/pagamento.model';

export interface FormaPagamentoComprovante {
    descritivo: string;
    valor: number;
    parcelas: number;
}

interface FormaPagamentoAgrupada {
    valor: number;
    qtdParcelas: number;
}

/**
 * Agrupa os itens de pagamento por descritivo, somando os valores e usando o
 * maior número de parcelas entre os itens do mesmo grupo.
 *
 * As parcelas vêm de `infoAdicional.numeroParcelas` de cada item — nunca da
 * contagem de itens agrupados.
 */
export const agrupaFormasPagamento = (
    itensPagamento: Array<IPagamentoRow>,
): Array<FormaPagamentoComprovante> => {
    const grupos: Record<string, FormaPagamentoAgrupada> = {};

    for (const item of itensPagamento) {
        const descritivo = item.descritivoFormaPagamento.toUpperCase();
        const parcelas = item.infoAdicional?.numeroParcelas ?? 1;

        const grupoExistente = grupos[descritivo];
        if (grupoExistente) {
            grupos[descritivo] = {
                valor: grupoExistente.valor + item.valor,
                qtdParcelas: Math.max(grupoExistente.qtdParcelas, parcelas),
            };
        } else {
            grupos[descritivo] = {
                valor: item.valor,
                qtdParcelas: parcelas,
            };
        }
    }

    return Object.keys(grupos).map(descritivo => ({
        descritivo,
        valor: grupos[descritivo].valor,
        parcelas: grupos[descritivo].qtdParcelas,
    }));
};
